import React, { memo, useState, useRef } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { Popper } from 'transfix-ui/components/Popper'
import { makeStyles } from 'transfix-ui/core/styles'
import CommissionTiersTable, { ICommissionTiersTableProps } from '../CommissionTiersTable'

const useCommissionTiersInfoTooltipStyles = makeStyles(() => ({
  icon: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export interface ICommissionTiersInfoTooltipProps extends ICommissionTiersTableProps {}

const CommissionTiersInfoTooltip = memo<ICommissionTiersInfoTooltipProps>(
  ({ loading, rate, tier1Max, tier2Max, tier3Max }) => {
    const classes = useCommissionTiersInfoTooltipStyles()

    const [isOpen, setOpen] = useState(false)
    const anchorEl = useRef<HTMLDivElement>(null)
    return (
      <div>
        <div
          className={classes.icon}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          ref={anchorEl}>
          <InfoIcon size='medium' color='coolGray5' />
        </div>
        <Popper open={isOpen} anchorEl={anchorEl.current}>
          <CommissionTiersTable
            rate={rate}
            tier1Max={tier1Max}
            tier2Max={tier2Max}
            tier3Max={tier3Max}
            loading={loading}
          />
        </Popper>
      </div>
    )
  }
)

export default CommissionTiersInfoTooltip
